import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-40 md:pt-48 pb-20 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-luminosity"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/50 via-gray-950/80 to-gray-950"></div>
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
      </div>

      <div className="container-custom relative z-10 text-center">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-5xl mx-auto"
        >
          <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full glass-panel mb-8 border-cyan-500/30">
            <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse"></span>
            <span className="text-cyan-300 font-medium text-base tracking-widest uppercase font-display">
              Strategy. Technology. Growth.
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold tracking-tight mb-8 leading-[1.1]">
            One Team for Everything Your Business Needs to <br />
            <span className="text-gradient">Grow Online.</span>
          </h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-gray-400 mb-12 leading-relaxed max-w-3xl mx-auto font-light">
            LAJ Digital combines marketing strategy, website development, lead generation, custom software, and AI-powered automation into one complete digital growth team.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link to="/" state={{ scrollTo: 'contact' }} className="btn-neon w-full sm:w-auto text-lg">
              Let's Talk About Your Growth
            </Link>
            <Link to="/" state={{ scrollTo: 'services' }} className="btn-hollow w-full sm:w-auto text-lg">
              Explore Our Services
            </Link>
          </div>

          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 1 }}
            className="mt-20 pt-8 border-t border-gray-800/50 inline-block"
          >
            <p className="text-base text-gray-500 tracking-wide">
              Founded by Lee Sommers of Sommers Marketing Group <br className="md:hidden" />
              and Anthony and Joseph Idi of Dapper Dev LLC.
            </p>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default Hero;